<template>
  <div style="width:100%;height:100%;">
    <myScroll style="width:100%;height:100%;"
              @handle-scroll="handleScroll"
              ref="vs">

      <div class="home-box">
        <div class="info-box">
          <div class="welcom-title">
            <span>{{$t('home.Welcome')}}, {{userInfo.FullName}}</span>
          </div>
          <div class="project-box">
            <span class="name"
                  :title="project.Name">{{project.Name}}</span>
            <div class="button-box">
              <el-button size="mini"
                         @click="openProjectDialog()"
                         v-has="'Edit Project'"
                         class="button-custom "
                         style="margin-left:8px;"> {{$t('home.EditProject')}}</el-button>
              <el-button size="mini"
                         @click="closeProject()"
                         v-has="'Close Project'"
                         class="button-custom "
                         v-if="!project.IsClosed"
                         style="margin-right:8px;"> {{$t('home.CloseProject')}}</el-button>
              <el-button size="mini"
                         @click="reopenProject()"
                         v-has="'Close Project'"
                         class="button-custom"
                         v-if="project.IsClosed"
                         style="margin-right:8px;width:140px"> {{$t('home.ReopenProject')}}</el-button>
            </div>
            <div class="pro">
              {{$t('home.Progress')}}: <label class="pro-rate">{{dashboard.Progress>0?dashboard.Progress.toFixed(0):'0'}}%</label>
            </div>
            <div class="text">
              <div class="address">{{project.addressText}}</div>
              <div style="margin-top:10px">
                {{$t('home.CreateBy',[project.CreatedBy,project.beforeText])}}
              </div>
            </div>
          </div>
          <div class="box-line"
               :style="{top:toTop+'px'}"
               id="boxLine"
               ref="boxLine">
            <el-row :gutter="20">
              <el-col :span="8"
                      class="plan">
                <div class="plan-box"
                     @click='toDiagrams()'>
                  <p class="title">{{$t('home.PLANS')}}</p>
                  <span class="count">
                    {{dashboard.PlanCount}}
                  </span>
                </div>
                <el-dropdown @command="handleAddPlanCommand"
                             v-if="M2Integration"
                             v-has="'Add Plan'"
                             class="dropdown-custom">
                  <el-button type="default"
                             icon="el-icon-plus">
                    {{$t('home.AddPlan')}}
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">{{$t('project.CreateWithPdfs')}}</el-dropdown-item>
                    <el-dropdown-item command="2">{{$t('project.CreateWithCloud')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button v-else
                           size="mini"
                           @click="openAddPlanFromPdfDialog()"
                           v-has="'Add Plan'"
                           class="button-custom"
                           icon="el-icon-plus"> {{$t('home.AddPlan')}} </el-button>
              </el-col>
              <el-col :span="8">
                <div class="task-box"
                     @click='toTask()'>
                  <p class="title">{{$t('home.TASKS')}}</p>
                  <div class="task-count count-left">{{$t('home.Open')}}
                    <span>{{dashboard.OpenTaskCount}}</span>
                  </div>
                  <div class="task-count count-right">{{$t('home.All')}}
                    <span>{{dashboard.AllTaskCount}}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="report-box"
                     @click="toReport()">
                  <p class="title">{{$t('home.REPORTS')}}</p>
                  <span class="count">{{dashboard.ReportCount}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="activity-card"
             v-loading="loading"
             ref="activityCard">
          <span class="title">{{$t('home.Activities')}}</span>
          <div class="activity-list">
            <div class="list-cube"
                 v-for="i in activityList"
                 :key="i.index">
              <div class="user-logo">
                <img v-if="i.act"
                     :src="i.act"
                     alt="">
                <img v-else
                     src="../../../assets/image/avatar.png"
                     alt="">
              </div>
              <h3>{{i.Title}}</h3>
              <div class="date"> {{i.BeforeText}}</div>
            </div>
            <div v-if="activityList.length === 0"
                 class="list-cube no-data">
              {{$t('home.NoData')}}
            </div>
          </div>
        </div>
        <Project-Dialog :showDialog="projectDialog.showDialog"
                        @closeDialog="closeProjectDialog">
        </Project-Dialog>
        <Diagrams-Dialog :showDialog="diagramsDialog.showDialog"
                         :openFrom="diagramsDialog.openFrom"
                         @closeDialog="closeDiagramsDialog"></Diagrams-Dialog>
        <addPlanFromPdfDialog :showDialog="addPlanFromPdfDialog.showDialog"
                              @closeDialog="closeAddPlanFromPdfDialog">
        </addPlanFromPdfDialog>
        <!--   <addPlanFromPdfKitDialog :showDialog="addPlanFromPdfDialog.showDialog"
                                 @closeDialog="closeAddPlanFromPdfDialog">
        </addPlanFromPdfKitDialog> -->
      </div>
    </myScroll>
  </div>
</template>

<script>
import ProjectDialog from '@components/project/projectDialog'
import { getProjectDetail, closeProject, getObjectActivities, getCorpUserById, reopenProject } from '@/api/config'
import { mapState } from 'vuex'
import DiagramsDialog from '@components/diagrams/diagramsDialog.vue'
import addPlanFromPdfDialog from '@/components/diagrams/addPdfPlanDialog.vue'
// import addPlanFromPdfKitDialog from '@/components/diagrams/addPlanFromPdfKitDialog.vue'

export default {
  data () {
    return {
      loading: false,
      projectDialog: {
        showDialog: false
      },
      hoverLeft: false,
      hoverRight: false,
      left: 'left',
      leftOn: 'left-hover',
      right: 'right',
      rightOn: 'right-hover', // 样式相关
      project: {}, // 数据相关
      dashboard: {},
      avatarUrl: '',
      activityList: [],
      activityTotal: 0, // 获取数据
      activityCondition: {
        PageIndex: 1,
        PageSize: 20,
        IsApp: false,
        OnlyCanDisplay: true,
        JobsiteId: null,
        OrderBy: 'CreatedOn desc'
      },
      diagramsDialog: {
        showDialog: false,
        step: 1,
        openFrom: 'Project'
      },
      addPlanFromPdfDialog: {
        showDialog: false
      },
      top: 0,
      toTop: 0,
      fix: false,
      actTop: 0
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'jobsiteName', 'userInfo', 'M2Integration'])
  },
  created () {
    this.getProjectDetail()
    this.getObjectActivities()
  },
  mounted () {
  },
  watch: {
    jobsiteID (to, from) {
      if (to) {
        this.getProjectDetail()
        this.getObjectActivities()
      }
    },
    top (to, from) {
      if (to >= 347) {
        this.toTop = 347 + (to - 347)
        this.actTop = 250
        this.fix = true
      } else {
        this.fix = false
        this.actTop = 0
      }
    }
  },
  methods: {
    handleScroll (vertical, horizontal, nativeEvent) {
      this.top = vertical.scrollTop
    },
    toDiagrams () {
      this.$router.push({
        name: 'diagrams'
      })
    },
    toTask () {
      this.$router.push({
        name: 'tasks'
      })
    },
    toReport () {
      this.$router.push({
        name: 'reports-project'
      })
    },
    closeProjectDialog () {
      this.projectDialog.showDialog = false
      this.getProjectDetail()
      this.getObjectActivities()
    },
    openProjectDialog () {
      this.projectDialog.showDialog = true
    },
    getProjectDetail () {
      this.loading = true
      getProjectDetail(this.jobsiteID).then(res => {
        this.project = res
        let addressObj = {
          Street: this.project.Street,
          City: this.project.City,
          State: this.project.State,
          Country: this.project.Country,
          ZipCode: this.project.ZipCode
        }
        this.project.addressText = this.$config.Address(addressObj)
        this.dashboard = res.Dashboard
        this.project.beforeText = this.$config.beforeTimeText(this.project.CreatedOn)
        this.project.updateBeforeText = this.$config.beforeTimeText(this.project.LastUpdatedOn)

        /* this.project.beforeTime = (new Date().getTime() - new Date(this.project.CreatedOn).getTime()) / 1000
        let days = parseInt(this.project.beforeTime / 86400)
        let hours = parseInt(this.project.beforeTime / 3600) - 24 * days
        let minutes = parseInt(this.project.beforeTime % 3600 / 60)
        if (days > 0) {
          this.project.beforeText = days + ' days ago'
        } else if (days < 1) {
          this.project.beforeText = hours + ' hours ago'
        } else if (hours < 1) {
          this.project.beforeText = minutes + ' minutes ago'
        } */
        this.$store.commit('getCreator', this.project.CreatorId)
        this.$store.commit('getJobsiteName', this.project.Name)
        this.$store.commit('getJobsiteLocation', this.project.addressText)
        this.loading = false
      })
    },
    closeProject () {
      this.$confirm(this.$t('home.AreYouSureYouWantToCloseThisProject'), this.$t('home.TIPS'), {
        confirmButtonText: this.$t('home.Yes'),
        cancelButtonText: this.$t('home.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        let params = []
        params.push(this.jobsiteID)
        closeProject(params).then(res => {
          this.getProjectDetail()
          this.getObjectActivities()
        })
      }).catch(() => {
      })
    },
    reopenProject () {
      this.$confirm(this.$t('home.AreYouSureYouWantToReopenThisProject'), this.$t('home.TIPS'), {
        confirmButtonText: this.$t('home.Yes'),
        cancelButtonText: this.$t('home.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        let params = []
        params.push(this.jobsiteID)
        reopenProject(params).then(res => {
          this.getProjectDetail()
        })
      }).catch(() => {
      })
    },
    handleCurrentActitityChange (val) {
      this.activityCondition.PageIndex = val
      this.getObjectActivities()
    },
    getObjectActivities () {
      this.loading = true
      this.activityCondition.JobsiteId = this.jobsiteID
      getObjectActivities(this.activityCondition).then(async res => {
        let actImgs = []
        for (let ele of res.Data) {
          let existImg = actImgs.find(q => q.id === ele.CreatorId)
          if (!existImg) {
            let act = await this.getCorpUserById(ele.CreatorId)
            if (act) {
              this.$set(ele, 'act', act)
            } else {
              this.$set(ele, 'act', '')
            }
            actImgs.push({ id: ele.CreatorId, act: act || '' })
          } else {
            this.$set(ele, 'act', existImg.act)
          }
          this.loading = false
          this.$config.labelActivity(ele, ele.CreatedBy)
        }
        this.activityList = res.Data
        this.activityTotal = res.TotalCount
      })
    },
    handleAddPlanCommand (command) {
      if (command === '1') {
        this.openAddPlanFromPdfDialog()
      } else if (command === '2') {
        this.openDiagramsDialog()
      }
    },
    openDiagramsDialog () {
      this.diagramsDialog.showDialog = true
    },
    openAddPlanFromPdfDialog () {
      this.addPlanFromPdfDialog.showDialog = true
    },
    closeDiagramsDialog () {
      this.diagramsDialog.showDialog = false
    },
    closeAddPlanFromPdfDialog (needRedirect) {
      this.addPlanFromPdfDialog.showDialog = false
      if (needRedirect) {
        this.$router.push({
          name: 'diagrams'
        })
      }
    },
    getCorpUserById (id) {
      return new Promise((resolve, reject) => {
        getCorpUserById(id).then(async res => {
          if (res.DocFileId && res.DocFileId.length > 0) {
            resolve(this.$config.baseURL + '/api/Attachments/' + res.DocFileId)
          } else {
            resolve()
          }
        })
      })
    }
  },
  components: {
    ProjectDialog,
    DiagramsDialog,
    addPlanFromPdfDialog
    // addPlanFromPdfKitDialog
  }
}
</script>

<style lang="scss">
.el-message-box {
  width: 450px;
}
</style>
<style scoped lang="scss">
.home-box {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  max-width: 1110px;
  height: 100%;
  .welcom-title {
    width: 100%;
    margin: 80px 0 60px 0;
    span:first-child {
      font-size: 24px;
      color: #535353;
      display: block;
      margin-bottom: 10px;
    }
    span:last-child {
      font-size: 18px;
      color: #959595;
    }
  }
  .project-box {
    width: 100%;
    background-color: #59c3ed;
    // background: url("../../../assets/image/overview_project.png") center
    //   no-repeat;
    // background-size: cover;
    height: 160px;
    border-radius: 4px;
    margin-bottom: 20px;
    overflow: hidden;
    position: relative;
    .name {
      font-size: 24px;
      color: #fff;
      font-weight: 600;
      margin: 20px 0 0 20px;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 320px);
    }
    .button-box {
      position: absolute;
      right: 16px;
      top: 16px;
      .button-custom {
        background: none;
        width: 120px;
        height: 36px;
        color: #fff;
        font-size: 16px;
        float: right;
        border: 1px solid #fff;
        &:hover {
          background-color: rgba(255, 255, 255, 0.4);
        }
      }
    }
    .pro {
      font-size: 16px;
      color: #fff;
      margin: 10px 20px;
      display: block;
      .pro-rate {
        font-size: 24px;
      }
    }
    .text {
      font-size: 16px;
      margin: 0 20px;
      color: #fff;
      display: block;
      .address {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .box-line {
    margin-bottom: 50px;
    width: 100%;
    height: 200px;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      margin-top: 20px;
      margin-left: 20px;
    }
    .plan {
      .plan-box {
        height: 200px;
        width: 100%;
        background: url("../../../assets/image/overview_plans.png") center
          no-repeat;
        background-size: cover;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .count {
          font-size: 36px;
          font-weight: 600;
          color: #fff;
          position: absolute;
          bottom: 25px;
          right: 20px;
        }
      }
      .dropdown-custom {
        position: absolute;
        left: 30px;
        bottom: 26px;
        &:hover {
          background-color: rgba(255, 255, 255, 0.4);
        }
        button {
          background: transparent;
          color: #fff;
        }
      }
      .button-custom {
        background: none;
        height: 36px;
        color: #fff;
        font-size: 16px;
        border: 1px solid #fff;
        position: absolute;
        left: 30px;
        bottom: 26px;
        &:hover {
          background-color: rgba(255, 255, 255, 0.4);
        }
      }
    }
    .task-box {
      height: 200px;
      width: 100%;
      background: url("../../../assets/image/overview_tasks.png") center
        no-repeat;
      background-size: cover;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      .task-count {
        font-size: 14px;
        color: #fff;
        span {
          font-size: 36px;
          font-weight: 600;
          color: #fff;
        }
      }
      .count-left {
        position: absolute;
        left: 20px;
        bottom: 25px;
      }
      .count-right {
        position: absolute;
        right: 20px;
        bottom: 25px;
      }
    }
    .report-box {
      height: 200px;
      width: 100%;
      background: url("../../../assets/image/overview_reports.png") center
        no-repeat;
      background-size: cover;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      .count {
        position: absolute;
        right: 20px;
        bottom: 25px;
        font-size: 36px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
  .box-line-fix {
    position: absolute;
    z-index: 10;
    background-color: #efeff5;
  }
  .activity-card {
    overflow: hidden;
    width: 100%;
    padding-bottom: 40px;
    .title {
      font-size: 17px;
      font-weight: 600;
      padding-bottom: 20px;
      display: block;
      border-bottom: 1px solid #d2d2d2;
      padding-left: 20px;
    }
    .list-cube {
      height: 70px;
      border-bottom: 1px solid #d2d2d2;
      overflow: hidden;
      position: relative;
      .user-logo {
        float: left;
        height: 40px;
        width: 40px;
        overflow: hidden;
        position: relative;
        border-radius: 50%;
        margin: 12px 5px 0;
        img {
          height: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          border-radius: 50%;
        }
      }
      h3 {
        font-size: 16px;
        color: #666;
        font-weight: normal;
        margin: 10px 10px 10px 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .date {
        font-size: 14px;
        color: #9c9c9c;
        margin-left: 60px;
      }
    }
  }
}
</style>
